export interface ThemeConfig {
  primaryColor: string;
  fontFamily: string;
}

export function createStyles(theme: ThemeConfig): string {
  return `
    .apidocs-widget {
      --primary-color: ${theme.primaryColor};
      --font-family: ${theme.fontFamily};

      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 999999;
      font-family: var(--font-family);
    }

    .apidocs-widget-button {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background-color: var(--primary-color);
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transition: transform 0.2s, box-shadow 0.2s;
    }

    .apidocs-widget-button:hover {
      transform: scale(1.05);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    .apidocs-widget-button svg,
    .apidocs-widget-button svg path {
      fill: white;
    }

    .apidocs-widget-button svg {
      width: 24px;
      height: 24px;
    }

    .apidocs-widget-notification {
      position: absolute;
      bottom: 72px;
      right: 0;
      width: 390px;
      max-width: calc(100vw - 40px);
      background: white;
      color: #333;
      font-size: 14px;
      line-height: 1.4;
      padding: 12px 32px 12px 14px;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
      cursor: pointer;
      opacity: 0;
      transform: translateY(8px);
      pointer-events: none;
      transition: opacity 0.25s ease, transform 0.25s ease;
    }

    .apidocs-widget-notification.visible {
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    }

    .apidocs-widget-notification-close {
      position: absolute;
      top: 4px;
      right: 6px;
      background: none;
      border: none;
      color: #999;
      cursor: pointer;
      font-size: 18px;
      line-height: 1;
      padding: 2px 4px;
    }

    .apidocs-widget-notification-close:hover {
      color: #333;
    }

    .apidocs-widget-chat {
      display: none;
      position: absolute;
      bottom: 70px;
      right: 0;
      width: 380px;
      height: 500px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
      flex-direction: column;
      overflow: hidden;
    }

    .apidocs-widget-chat.open {
      display: flex;
    }

    .apidocs-widget-chat.expanded {
      width: min(640px, calc(100vw - 40px));
      height: min(760px, calc(100vh - 110px));
    }

    .apidocs-widget-header {
      padding: 16px;
      background-color: var(--primary-color);
      color: white;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .apidocs-widget-header-actions {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .apidocs-widget-close {
      background: none;
      border: none;
      color: white;
      cursor: pointer;
      font-size: 20px;
      line-height: 1;
      padding: 4px;
    }

    .apidocs-widget-expand {
      background: none;
      border: none;
      color: white;
      cursor: pointer;
      line-height: 1;
      padding: 4px;
      display: flex;
      align-items: center;
      opacity: 0.9;
    }

    .apidocs-widget-expand:hover {
      opacity: 1;
    }

    .apidocs-widget-expand svg,
    .apidocs-widget-expand svg path {
      fill: white;
    }

    .apidocs-widget-expand svg {
      width: 16px;
      height: 16px;
    }

    .apidocs-widget-expand .apidocs-widget-icon-collapse {
      display: none;
    }

    .apidocs-widget-chat.expanded .apidocs-widget-expand .apidocs-widget-icon-expand {
      display: none;
    }

    .apidocs-widget-chat.expanded .apidocs-widget-expand .apidocs-widget-icon-collapse {
      display: block;
    }

    .apidocs-widget-messages {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .apidocs-widget-message {
      max-width: 85%;
      padding: 10px 14px;
      border-radius: 12px;
      line-height: 1.4;
      font-size: 14px;
    }

    .apidocs-widget-message.user {
      align-self: flex-end;
      background-color: var(--primary-color);
      color: white;
      border-bottom-right-radius: 4px;
    }

    .apidocs-widget-message.assistant {
      align-self: flex-start;
      background-color: #f1f1f1;
      color: #333;
      border-bottom-left-radius: 4px;
    }

    .apidocs-widget-message.assistant > *:first-child {
      margin-top: 0;
    }

    .apidocs-widget-message.assistant > *:last-child {
      margin-bottom: 0;
    }

    .apidocs-widget-message.assistant p {
      margin: 0 0 8px;
    }

    .apidocs-widget-message.assistant h1,
    .apidocs-widget-message.assistant h2,
    .apidocs-widget-message.assistant h3,
    .apidocs-widget-message.assistant h4,
    .apidocs-widget-message.assistant h5,
    .apidocs-widget-message.assistant h6 {
      margin: 12px 0 6px;
      line-height: 1.3;
    }

    .apidocs-widget-message.assistant h1 { font-size: 17px; }
    .apidocs-widget-message.assistant h2 { font-size: 16px; }
    .apidocs-widget-message.assistant h3 { font-size: 15px; }
    .apidocs-widget-message.assistant h4,
    .apidocs-widget-message.assistant h5,
    .apidocs-widget-message.assistant h6 { font-size: 14px; }

    .apidocs-widget-message.assistant ul,
    .apidocs-widget-message.assistant ol {
      margin: 0 0 8px;
      padding-left: 20px;
    }

    .apidocs-widget-message.assistant li {
      margin: 2px 0;
    }

    .apidocs-widget-message.assistant a {
      color: var(--primary-color);
      text-decoration: underline;
    }

    .apidocs-widget-sources {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    .apidocs-widget-sources-label {
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      opacity: 0.6;
      margin-bottom: 4px;
    }

    .apidocs-widget-source {
      font-size: 13px;
      margin: 2px 0;
    }

    .apidocs-widget-source a {
      color: var(--primary-color);
      text-decoration: none;
    }

    .apidocs-widget-source a:hover {
      text-decoration: underline;
    }

    .apidocs-widget-message.assistant code {
      background-color: rgba(0, 0, 0, 0.07);
      padding: 1px 4px;
      border-radius: 4px;
      font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
      font-size: 12px;
    }

    .apidocs-widget-message.assistant pre {
      background-color: rgba(0, 0, 0, 0.07);
      padding: 10px 12px;
      border-radius: 8px;
      overflow-x: auto;
      margin: 0 0 8px;
    }

    .apidocs-widget-message.assistant pre code {
      background: none;
      padding: 0;
      font-size: 12px;
      line-height: 1.45;
    }

    .apidocs-widget-input-container {
      padding: 12px;
      border-top: 1px solid #eee;
      display: flex;
      gap: 8px;
    }

    .apidocs-widget-hint {
      padding: 0 14px 10px;
      font-size: 11px;
      color: #999;
      text-align: right;
    }

    .apidocs-widget-hint kbd {
      font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
      font-size: 10px;
      background-color: rgba(0, 0, 0, 0.06);
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      padding: 1px 5px;
    }

    .apidocs-widget-input {
      flex: 1;
      padding: 10px 14px;
      border: 1px solid #ddd;
      border-radius: 20px;
      font-size: 14px;
      font-family: var(--font-family);
      outline: none;
    }

    .apidocs-widget-input:focus {
      border-color: var(--primary-color);
    }

    .apidocs-widget-send {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: var(--primary-color);
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.2s, filter 0.2s;
    }

    .apidocs-widget-send:hover:not(:disabled) {
      filter: brightness(1.1);
      transform: scale(1.05);
    }

    .apidocs-widget-send:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .apidocs-widget-send svg,
    .apidocs-widget-send svg path {
      fill: white;
    }

    .apidocs-widget-send svg {
      width: 18px;
      height: 18px;
    }

    .apidocs-widget-loading {
      display: flex;
      gap: 4px;
      padding: 10px 14px;
    }

    .apidocs-widget-loading span {
      width: 8px;
      height: 8px;
      background-color: #999;
      border-radius: 50%;
      animation: apidocs-bounce 1.4s infinite ease-in-out both;
    }

    .apidocs-widget-loading span:nth-child(1) { animation-delay: -0.32s; }
    .apidocs-widget-loading span:nth-child(2) { animation-delay: -0.16s; }

    @keyframes apidocs-bounce {
      0%, 80%, 100% { transform: scale(0); }
      40% { transform: scale(1); }
    }
  `;
}
